import React from 'react';
import SwitchBar from '../../components/switch-bar';
import { HeaderOptions } from '../clients/clients-constants';
import CalendarPaginator from '../../components/calender-paginator';
import { NumericLabel } from '../../components/common';
import RightArrow from '../../assets/images/left-arrow-symbol.svg';
import { StackedBarChart } from '../../components/charts';
import { VerticalBarChart } from '../../components/charts';

const options = {
  title: '',
  chartArea: { width: '50%', height: '90%' },
  colors: ['#1D1183'],
  legend: { position: 'none' },
  hAxis: {
    title: '',
    minValue: 0,
  },
  vAxis: {
    title: '',
  },
};

const data = [
  ['City', '2010 Population', { role: 'style' }, { role: 'annotation' }],
  ['New York City', 8175500, '', 8175500],
  ['New York City', 8175500, '', 8175500],
  ['New York Citym', 8174000, '', 8174000],
  ['Los Angeles', 3792300, '', 3792300],
  ['L A', 3792200, '', 3792200],
  ['Los Angels', 3791000, '', 3791000],
  ['Chicago', 2695900, '', 2695900],
  ['Chiccago', 2695400, '', 2695400],
  ['Chicago0', 2695100, '', 2695100],
  ['Houstoni', 2098000, '', 2098000],
  ['Housten', 2097000, '', 2097000],
  ['Houstren', 2097000, '', 2097000],
  ['Philadelphia', 1526000, '', 1526000],
  ['Philadelphib', 1525000, '', 1525000],
  ['Philadelphic', 1524000, '', 1524000],
];

const Connections = () => {
  return (
    <div className="w-full py-3">
      <div className="flex h-2/3 w-full items-end justify-between">
        <StackedBarChart xwidth={'14%'} backGroundColor={'stacked-bar-red-primary'} />
        <StackedBarChart xwidth={'63%'} backGroundColor={'stacked-bar-orange-primary'} />
        <StackedBarChart xwidth={'23%'} backGroundColor={'stacked-bar-green-primary'} />
      </div>
      <div className="text-gray-dark flex items-center py-1 text-sm"> Negative / Neutral / Positive</div>
    </div>
  );
};

const Configure: React.FunctionComponent = (): JSX.Element => {
  return (
    <div>
      {/* <Header userName={"Jason"} heading={<HeadBack clientName={ClientName}/>} /> */}
      <div className="bg-gray-background-light gray-border-line h-20 border-b px-2 py-4">
        <div className="gray-background-light flex items-center justify-between px-4 py-2">
          <div className="blue-primary flex items-center text-xl font-bold">
            <img className="mr-3 h-8 w-8" src={RightArrow} alt="left Arrow"></img>Sample Group
          </div>

          <div className="text-gray-dark flex items-center justify-between text-sm font-medium">
            <button className="stacked-bar-orange-primary mx-5 rounded-full px-5 py-1 text-white">SET UP</button>
            <div className="px-3">Dec 14th 2021 </div>
            <div className="px-3">{`Hello, Jason`}</div>
            <button className="rounded-full bg-white px-5 py-2 text-sm">LOG OUT </button>
          </div>
        </div>
      </div>
      <SwitchBar heading={HeaderOptions} position={4} />
      <CalendarPaginator />

      <div className="max-window-height-group overflow-y-auto px-7">
        <div className="w-full">
          <div className="flex justify-between py-4">
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">
              Total Eligible Members
            </div>
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">Activated Members</div>
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">Engaged Members</div>
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">Connected Members</div>
          </div>
          <div className="flex justify-between">
            <div className="w-1/4">
              <NumericLabel numericValue={'15,382'} label={''} />
            </div>
            <div className="w-1/4">
              <NumericLabel numericValue={'9,754'} label={'63%'} />
            </div>
            <div className="w-1/4">
              <NumericLabel numericValue={'5,766'} label={'37%'} />
            </div>
            <div className="w-1/4">
              <NumericLabel numericValue={'3,651'} label={'23%'} />
            </div>
          </div>
        </div>

        <div className="flex justify-between">
          <div className="w-full flex-col">
            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              Check-ins
            </div>
            <div className="flex w-3/4 justify-between">
              {/* <Histogram error={false} data={data} options={options} /> */}
              <div className="blue-primary py-3 text-2xl">6439</div>
              <div className="flex-col">
                <div className="blue-primary py-3 text-2xl">19%</div>
                <span>36,455 sent</span>
              </div>
            </div>

            <div className="text-gray-dark relative w-full border-b py-3 text-base font-bold">Mood Distribution</div>
            <Connections />

            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              Story Listens
            </div>
            <div className="flex w-3/4 justify-between">
              {/* <Histogram error={false} data={data} options={options} /> */}
              <div className="blue-primary py-3 text-2xl">6439</div>
              <div className="flex-col">
                <div className="blue-primary py-3 text-2xl">19%</div>
                <span>Of Members</span>
              </div>
            </div>

            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              Calls
            </div>
            <div className="flex w-3/4 justify-between">
              {/* <Histogram error={false} data={data} options={options} /> */}
              <div className="blue-primary py-3 text-2xl">6439</div>
              <div className="flex-col">
                <div className="blue-primary py-3 text-2xl">19%</div>
                <span>Of Members</span>
              </div>
            </div>

            <div className="gray-border-line text-gray-dark relative flex w-full border-b py-3 text-base font-bold">
              Engagement by Tag
            </div>
            <div className="w-3/4">
              {/* <WeeklyChart error={false} /> */}
              <VerticalBarChart data={data} options={options} />
            </div>
          </div>
          <div className="w-full px-7">
            <div className="gray-border-line text-gray-dark relative flex w-full border-b py-3 text-base font-bold">
              Topics of Interests
            </div>
            <div className="w-1/2">
              {/* <WeeklyChart error={false} /> */}
              <VerticalBarChart data={data} options={options} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Configure;
